import {
  INCREMENT_ORDER_CURRENT_PAGE,
  ORDER_CREATE_DONE,
  ORDER_CREATE_START,
  ORDERS_ADD,
  ORDERS_FETCH,
  ASYNC_ORDER_COMPLETED,
  ASYNC_ORDER_FAILED,
  START_ASYNC_ORDER_FETCH,
} from "../constants/actionTypes";
import { CREATE_TPOS_ORDER } from "../constants/actionTypesTpos";
import { ActionType } from "../types/action-types";
import { OrderType } from "../types/order";

export function doCreateOrderStart(): ActionType<undefined> {
  return { type: ORDER_CREATE_START };
}

export function doCreateOrderDone(
  payload?: OrderType,
  keepProcessing: boolean = false,
): ActionType<{ order?: OrderType; keepProcessing: boolean }> {
  return {
    type: ORDER_CREATE_DONE,
    payload: { order: payload, keepProcessing },
  };
}

export function doAsyncOrderCompleted(): ActionType<undefined> {
  return { type: ASYNC_ORDER_COMPLETED };
}

export function doAsyncOrderFailed(): ActionType<undefined> {
  return { type: ASYNC_ORDER_FAILED };
}

export function doStartAsyncOrderFetch(orderId: number): ActionType<number> {
  return { type: START_ASYNC_ORDER_FETCH, payload: orderId };
}

export function createTposOrder(): ActionType<undefined> {
  return { type: CREATE_TPOS_ORDER };
}

export function doFetchOrders(isPaginatedLoad: boolean): ActionType<boolean> {
  return {
    type: ORDERS_FETCH,
    payload: isPaginatedLoad,
  };
}

export function doAddOrders(orders: OrderType[]): ActionType<OrderType[]> {
  return {
    type: ORDERS_ADD,
    payload: orders,
  };
}

export function incrementOrderCurrentPage(): ActionType<undefined> {
  return {
    type: INCREMENT_ORDER_CURRENT_PAGE,
  };
}
